import React from "react";
import MessagesSection from "./MessagesSection";
import VisitsChart from "./VisitsChart";
import { ToastContainer } from "react-toastify";

const Dashboard = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Messages (plein largeur, en haut) */}
      <MessagesSection />

      {/* Visites (plein largeur, en bas) */}
      <VisitsChart />

      {/* Idéalement une seule fois dans l’app */}
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default Dashboard;
